<template>
	<el-container>
		<Menu :activeIndex='activeIndex'></Menu>
		<el-container>
			<el-header>
				<h2>优惠券管理</h2>
			</el-header>
			<el-main>
				<div class='editConpon clearfix'>
					<div class='box_item'>
						优惠券金额：
						<el-input style="width:300px" placeholder="金额" type="number" v-model="conponMon"></el-input> 元
					</div>
					<div class='box_item' style="width:80%;">
						优惠券用途：
						<el-input style="width:600px" placeholder="优惠券用途" v-model="conpontype"></el-input>
					</div>
					<div class="box_item ">
						<el-button type="primary" v-on:click="addConpontype">新建优惠券</el-button>
					</div>

					<!--<div class="box_item">
						<el-button type="success" style="margin-bottom:20px;" v-on:click='sendConpon' :disabled='sendState'>赠送优惠券</el-button>
					</div>-->
				</div>

				<el-table ref="multipleTable" :data="tableData" :stripe="true" tooltip-effect="dark" style="width: 100%">
					<!--<el-table-column type="selection" width="55">
					</el-table-column>-->
					<el-table-column prop="instructions" label="用途" width="300" :show-overflow-tooltip="true">
					</el-table-column>
					<el-table-column prop="amount" label="金额" width="120" :show-overflow-tooltip="true">
					</el-table-column>
					<!--<el-table-column label="操作">
						<template slot-scope="scope">
							<el-button type="success" size="mini" plain v-on:click="sendOneConpon(scope.row.openid)">赠送优惠券</el-button>
						</template>
					</el-table-column>-->
				</el-table>

				<!--查看优惠券-->

			</el-main>
			<el-footer>Copyright &copy; Soren外刊精读 技术支持 ：
				<a href="#">苏州西西弗斯商务信息咨询有限公司</a>
			</el-footer>
		</el-container>

	</el-container>

</template>

<script>
	export default {
		data() {
			return {
				activeIndex: "6",
				tableData: [],
				multipleSelection: [],
				conponMon: 0,
				sendState: true,
				dialogTableVisible:false,
				rangeDate:null, //优惠券起止时间
				pointData: [],
				currentPage1:1,
				pagecount:20,
				dataTotal:0,
				searchname:'',
				conpontype:''
			};
		},
		created() {

		},
		updated: function() {

		},
		mounted(){
			this.getVipPerSons();
		},
		methods: {
			addConpontype:function(){
				var that = this;
				if(that.conponMon == 0){
					that.$message({
						type: "error",
						message: "金额不能为0"
					});
				}else if(that.conpontype == ""){
					that.$message({
						type: "error",
						message: "用途不能为空"
					});
				}else{
					that.axios.post("coupon/add", {
						mark: localStorage.getItem("mark"),
						amount:that.conponMon,
						instructions:that.conpontype
					})
					.then(function(response) {
						console.log(response);
						if(response.data.code == "600") {
							that.$message({
								type: "suceess",
								message: "添加成功"
							});
							that.getVipPerSons();
							that.conponMon = 0;
							that.conpontype = "";
						} else if(response.data.code == "400") {
							that.$message({
								type: "error",
								message: "操作失败"
							});
						}
					})
					.catch(function(error) {
						console.log(error);
					});
				}
			},
			getVipPerSons: function() {
				var that = this;
				console.log("@@@@@@@@@@@@@");
				that.axios.post("/coupon/list", {
					mark: localStorage.getItem("mark")
				})
				.then(function(response) {
					console.log(response);
					if(response.data.code == "600") {
						that.tableData = response.data.data;
					} else if(response.data.code == "400") {
						that.$message({
							type: "error",
							message: "操作失败"
						});
					} else {
						that.ifLogin();
					}
				})
				.catch(function(error) {
					console.log(error);
				});
			}
		},
		watch: {

		}
	};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped="scoped">
	.clearfix:after,
	#container:after {
		content: "\0020";
		display: block;
		height: 0;
		clear: both;
		visibility: hidden;
		overflow: hidden
	}

	.editConpon {
		background: #fff;
		padding: 20px;
		margin-bottom: 20px;
	}

	.editConpon .box_item {
		margin-bottom: 15px;
		width:50%;
	}
	.myCoupon .coupon_card{
		padding:20px;
	}

	.myCoupon .item {
	  box-shadow: 0 0 10px #ccc;
	  background: #fff;
	  padding:6px 23px;
	  margin-bottom:10px;
	  border-radius:6px;
	  position: relative;
	  overflow:hidden;
	}

	.myCoupon .item._no{
	  font-size:18px;
	  line-height:36px;
	}

	.myCoupon .item .choiced_img {
	  position: absolute;
	  right:30px;
	  bottom:20px;
	  width:160px;
	  height:50px;
	  background: #c6c6c6;
	  border-radius:30px;
	  font-size:25px;
	  text-align:center;
	  line-height:50px;
	  background:#f74459;
	}
	.myCoupon .item .choiced_img a{
		color:#fff;
	}
	.myCoupon .item .choiced_img._use {
	  background: #e3432d;
	}

	.myCoupon .item .choiced_img img {
	  width: 100%;
	  height: 100%;
	  display: block;
	}

	.myCoupon .item ._detail {
	  color: #f74459;
	  position: relative;
	  margin-bottom:10px;
	  font-size:14px;
	}

	.myCoupon .item ._detail ._big {
	  font-size:26px;
	  font-weight: 600;
	}

	.myCoupon .item ._detail .item_points {
	  position: absolute;
	  right: 0;
	  top:2px;
	  color: #898989;
	  font-size:14px;
	  margin:0;
	}

	.myCoupon .item ._time {
	  color: #898989;
	  font-size:14px;
	  line-height:25px;
	}

	.myCoupon .plusNum {
	  /* position: fixed;
	  right: 0;
	  bottom: 0; */
	  height:70px;
	  display: flex;
	  flex-direction: row;
	  flex-wrap: wrap;
	}

	.myCoupon .plusNum ._use {
	  background: #1aad16;
	  color: #fff;
	  width:20%;
	  text-align:center;
	  line-height:70px;
	  font-size:18px;
	}
	.myCoupon .plusNum ._price {
	  width:80%;
	  line-height:50px;
	  text-align:right;
	  box-sizing:border-box;
	  padding-right:30px;
	}
	.myCoupon .plusNum ._price text{
	  font-size:24px;
	  color:#f74459;
	}

	.myCoupon .item ._used{
	  position:absolute;
	  width:90px;
	  height:90px;
	  right:160px;
	  top:3px;
	  z-index: 2;
	}
	.myCoupon .item ._used img{
	  display:block;
	  width:100%;
	  height:100%;
	}

</style>



// WEBPACK FOOTER //
// src/components/ConponCharge.vue